const translations = {
  "site.name": "心语共鸣",
  "site.tagline": "不喜欢色色的我吗——真实情感表达落地页",
  "site.description": "探索自我认同、情感沟通与亲密关系中的真实需求，找到属于自己的答案。",
  "nav.home": "首页",
  "nav.categories": "分类浏览",
  "nav.about": "关于我们",
  "nav.contact": "联系我们",
  "hero.title": "不喜欢色色的我吗",
  "hero.subtitle": "这句话背后藏着多少人的自我怀疑与情感困惑？",
  "hero.description": "我们深度解析这句流行表达的情感内核，帮助你理解自我认同、情感沟通与亲密关系中的真实需求。在这里，每一种情感都值得被看见，每一个真实的你都值得被喜欢。",
  "hero.cta": "开始探索",
  "hero.secondary": "了解更多",
  "section.featured": "精选文章",
  "section.featured.desc": "为你精选最受欢迎的情感深度文章",
  "section.categories": "探索话题",
  "section.categories.desc": "选择你感兴趣的情感话题，找到属于你的答案",
  "section.faq": "常见问题",
  "section.faq.desc": "关于情感自我认同，你可能想了解的",
  "section.newsletter": "订阅我们的情感周报",
  "section.newsletter.desc": "每周一封温暖的信，陪你一起探索内心的世界",
  "section.newsletter.placeholder": "输入你的邮箱地址",
  "section.newsletter.button": "免费订阅",
  "section.newsletter.success": "订阅成功！欢迎加入我们的情感社区。",
  "section.newsletter.error": "订阅失败，请稍后再试。",
  "article.readMore": "阅读全文",
  "article.related": "相关文章",
  "article.share": "分享文章",
  "article.publishedOn": "发布于",
  "article.author": "作者",
  "article.category": "分类",
  "article.backToList": "返回文章列表",
  "article.minRead": "分钟阅读",
  "breadcrumb.home": "首页",
  "category.all": "全部文章",
  "category.title": "分类浏览",
  "category.desc": "选择你感兴趣的话题，深入探索情感世界",
  "category.noArticles": "该分类下暂无文章",
  "about.title": "关于我们",
  "about.subtitle": "心语共鸣——让每一种情感都被温柔以待",
  "about.story": "品牌故事",
  "about.story.content": "「不喜欢色色的我吗」不仅仅是一句网络流行语，它是当代年轻人在亲密关系中的真实困惑。心语共鸣创立于2024年，由一群心理学爱好者和情感内容创作者共同发起。我们发现，太多人在亲密关系中隐藏真实的自己，害怕表达真实的情感需求，最终陷入自我怀疑的漩涡。我们希望通过温暖、专业、真诚的内容，帮助每一个人找到自我认同的勇气，学会在亲密关系中表达真实的自己。",
  "about.mission": "我们的使命",
  "about.mission.content": "用心理解每一种情感，用文字温暖每一颗心灵。我们致力于成为中文互联网上最温暖的情感内容平台，帮助年轻人在自我认同和亲密关系中找到方向和力量。",
  "about.reputation": "用户口碑",
  "about.reputation.desc": "来自读者的真实反馈",
  "about.contact": "联系我们",
  "about.contact.desc": "有任何问题或建议，欢迎随时联系我们",
  "about.contact.name": "姓名",
  "about.contact.namePlaceholder": "请输入你的姓名",
  "about.contact.email": "邮箱",
  "about.contact.emailPlaceholder": "请输入你的邮箱",
  "about.contact.message": "留言",
  "about.contact.messagePlaceholder": "请输入你想说的话（最多500字）",
  "about.contact.submit": "发送留言",
  "about.contact.success": "留言发送成功！我们会尽快回复你。",
  "about.contact.error": "发送失败，请稍后再试。",
  "footer.rights": "© 2024 心语共鸣 版权所有",
  "footer.links": "快速链接",
  "footer.social": "关注我们",
  "footer.privacy": "隐私政策",
  "footer.terms": "使用条款",
  "scrollToTop": "回到顶部",
  "loading": "加载中...",
};

export default translations;